const isOverflowed = (el, padding = 0) => {
  if (!el) return;
  const range = document.createRange();
  range.setStart(el, 0);
  range.setEnd(el, el.childNodes.length);
  // 所有子节点的宽度总和
  const rangeWidth = range.getBoundingClientRect().width;
  // 内容实际宽度
  const scrollWidth = rangeWidth + padding;
  // 内容当前宽度
  const clientWidth = el.getBoundingClientRect().width;
  return clientWidth < scrollWidth;
};

export default isOverflowed;
